export const FOCUS_AREA_NONE = 0;
export const FOCUS_AREA_AGE_GROUP = 1;
export const FOCUS_AREA_COMPANY = 2;
export const FOCUS_AREA_GENDER = 3;
export const FOCUS_AREA_NATIONALITY = 4;

export const FOCUS_AREA_EDUCATION_LEVEL = 5;
export const FOCUS_AREA_MARITAL_STATUS = 6;
export const FOCUS_AREA_PROFESSION = 7;

export const FOCUS_AREA_REGION = 10;
export const FOCUS_AREA_LOCALITY = 11;
export const FOCUS_AREA_SUB_LOCALITY = 12;
export const FOCUS_AREA_BRANCH = 13;

export const FOCUS_AREA_MONTH_TIMELINE = 20;
export const FOCUS_AREA_DAY_TIMELINE = 21;
export const FOCUS_AREA_DAY_OF_WEEK_TIMELINE = 22;
export const FOCUS_AREA_HOUR_TIMELINE = 23;

export const FOCUS_AREA_EMPLOYEE_AGE_GROUP = 30;
export const FOCUS_AREA_EMPLOYEE_GENDER = 31;
export const FOCUS_AREA_EMPLOYEE_LOCALITY = 32;
export const FOCUS_AREA_EMPLOYEE_NAME = 33;

export const FOCUS_AREA_TRANSACTION_TYPES = 40;
export const FOCUS_AREA_GIFT = 41;
export const FOCUS_AREA_OFFER = 42;
export const FOCUS_AREA_RATING = 43;
export const FOCUS_AREA_PRODUCT = 44;
export const FOCUS_AREA_PRODUCT_ACTION = 45;
export const FOCUS_AREA_PROFILE_ACTION = 46;

export const FOCUS_AREA_TOP_CUSTOMER = 50;
export const FOCUS_AREA_BOTTOM_CUSTOMER = 51;
export const FOCUS_AREA_TOP_EMPLOYEE = 52;
export const FOCUS_AREA_BOTTOM_EMPLOYEE = 53;

export const FOCUS_AREA_ACTIVITY = 60;
export const FOCUS_AREA_ACTIVITY_ACTION = 61;
export const FOCUS_AREA_ACTIVITY_RATING = 62;
export const FOCUS_AREA_TRANSFERRED_TO = 63;

export const FOCUS_AREA_BUSINESS = 70;
export const FOCUS_AREA_BUSINESS_CATEGORY = 71;

export const FOCUS_AREA_INTEREST = 100;


export const FILTER_GENDER = 'fg';
export const FILTER_AGE_GROUP = 'fag';
export const FILTER_NATIONALITY = 'fn';

export const FILTER_COUNTRY = 'fco';
export const FILTER_REGION = 'fr';
export const FILTER_LOCALITY = 'fl';
export const FILTER_SUB_LOCALITY = 'fsl';

export const FILTER_FROM_DATE = 'fsa';
export const FILTER_TO_DATE = 'fea';
export const FILTER_MONTH = 'fm';
export const FILTER_DAY = 'fd';
export const FILTER_WEEK_DAY = 'fdw';
export const FILTER_HOUR = 'fdh';

export const FILTER_RATING = 'fra';

export const FILTER_INTEREST = 'sfq';
export const FILTER_INTEREST_OPTION = 'sfan';

export const FILTER_SHOWCASE = 'fsc';

export const FILTER_TYPE_DROP_DOWN = 1;
export const FILTER_TYPE_DATE = 2;
export const FILTER_TYPE_RADIO = 3;

export default class InsightFilterHelper {

    static getType(filterId) {
        if (filterId === FILTER_RATING) {
            return FILTER_TYPE_RADIO;
        }
        if (filterId === FILTER_FROM_DATE
            || filterId === FILTER_TO_DATE) {
            return FILTER_TYPE_DATE;
        }
        if (filterId === FILTER_GENDER || filterId === FILTER_NATIONALITY || filterId === FILTER_AGE_GROUP
            || filterId === FILTER_COUNTRY || filterId === FILTER_REGION || filterId === FILTER_LOCALITY || filterId === FILTER_SUB_LOCALITY
            || filterId === FILTER_MONTH || filterId === FILTER_WEEK_DAY || filterId === FILTER_DAY || filterId === FILTER_HOUR
            || filterId === FILTER_INTEREST || filterId === FILTER_INTEREST_OPTION || filterId === FILTER_SHOWCASE) {
            return FILTER_TYPE_DROP_DOWN;
        }
    }
}
